import type { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import type { ApiErrorInterface } from '@zaoblako/shared/common/dtos/api-error.dto';
import type { SerdeDtoMetadataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-dto-metadata.interface';

/** Base HTTP exception class */
export class BaseHttpException<T = any >extends Error implements ApiErrorInterface<T> {
  public status: number;

  /** Validation metadata */
  public validationMetadata?: T extends Array<infer I> ? SerdeDtoMetadataInterface<I> : SerdeDtoMetadataInterface<T>;

  public validationErrors?: T extends Array<infer I> ? Array<ValidationErrorInterface<I>> : ValidationErrorInterface<T>;

  /**
   * @param [status] HTTP statuse code
   * @param [name] HTTP error system name
   * @param [message] User-readable error message
   * @param [options] Additional error options
   */
  public constructor(
    status?: number,
    name?: string,
    message?: string,
    options?: ErrorOptions,
  ) {
    super(message || 'Internal Server Error', options);
    this.status = status || 500;
    this.name = name || 'InternalServerError';
  }

  /** Serialize error instance */
  public toJSON(): ApiErrorInterface {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      status: this.status,
      validationMetadata: this.validationMetadata,
      validationErrors: this.validationErrors,
    };
  }
}
